import { render, staticRenderFns } from "./DeleteAcceptDialog.vue?vue&type=template&id=d8a65178&scoped=true"
import script from "./DeleteAcceptDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAcceptDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteAcceptDialog.vue?vue&type=style&index=0&id=d8a65178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a65178",
  null
  
)

export default component.exports